import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { RoleService } from 'app/core/_services/role.service';
import { UtilitiesService } from 'app/core/_services/utilities.service';
import { UserService } from "../core/_services/user.service";

@Component({
    selector: 'app-loginas',
    templateUrl: './loginas.component.html'
})
export class LoginasComponent implements OnInit {

    error = false;
    errorMessage = "";

    constructor(private route: ActivatedRoute,
        private router: Router,
        private utilitiesService: UtilitiesService,
        private roleService: RoleService,
        private userService: UserService) { } // constructor()

    ngOnInit() {
        this.utilitiesService.setLocal("userData", '');
        this.userService.updateUserData({});
        this.roleService.setUserRole(null);
        this.route.queryParams.subscribe(params => {
            const token = params['t'];
            const jobId = params['jobId'];
            const techProfile = params['techProfile'];
            const serviceReport = params['servicereport'];
            this.userService.loginWithToken(token).subscribe(
                result => {
                    if (jobId && serviceReport) {
                        this.router.navigate(['/appointments'], {queryParams: {jobId: jobId, serviceReport: true}});
                    } else if (techProfile) {
                        this.router.navigate(['/mechanic/' + techProfile]);
                    } else {
                        this.userService.setLoginAs(true);
                        this.router.navigate(['/account']);
                    }
                },
                error => {
                    this.error = true;
                    this.errorMessage = "Error logging in! Please try again later!";
                }
            );
        });
    } // ngOnInit()

} // LoginasComponent
